"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var InputHelper_1 = require("../InputHelper");

var Radio_1 = require("./Radio");

var Direction;

(function (Direction) {
  Direction["VERTICAL"] = "";
  Direction["HORIZONTAL"] = "lsg--input-group-inner__horizontal";
})(Direction || (Direction = {}));
/**
 * InputGroup wraps inputs in a fieldset. It can also be used to create error-/helpertexts that will be displayed for the whole fieldset - not for one input only.
 * Check our `<Input...>` components to see implementation examples.
 */


var InputGroup =
/** @class */
function (_super) {
  __extends(InputGroup, _super);

  function InputGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputGroup.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        direction = _a.direction,
        label = _a.label,
        errorText = _a.errorText,
        helperText = _a.helperText;
    return React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "input-group"
    }, React.createElement("legend", {
      className: CSSPrefix_1.lsgPre + "input-group-label"
    }, label), React.createElement("fieldset", {
      className: CSSPrefix_1.lsgPre + "input-group-fieldset"
    }, React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "input-group-inner", CSSPrefix_1.prefixEnumClassNames(direction), className])
    }, children)), React.createElement(InputHelper_1.InputHelper, {
      helperText: helperText,
      errorText: errorText
    }));
  };

  InputGroup.defaultProps = {
    direction: Direction.VERTICAL
  };
  InputGroup.Directions = Direction;
  InputGroup.Radio = Radio_1.Radio;
  return InputGroup;
}(React.Component);

exports.InputGroup = InputGroup;